import React, { useState } from 'react';
import { sendBlogQuestion } from '../services/api';
import { trackTelemetryEvent } from '../utils/anonymousTelemetry';

// Reader question box shown under every blog post. Questions go through the existing
// /messages/ endpoint (emailed to support@). Answers are published by adding them to the
// post's "Questions from readers" section in blog-posts/<slug>.json; no code change per post.
function BlogQuestionBox({ slug, title }) {
  const [question, setQuestion] = useState('');
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [website, setWebsite] = useState(''); // honeypot, hidden from people
  const [state, setState] = useState('idle');

  const onSubmit = async (event) => {
    event.preventDefault();
    if (website || question.trim().length < 10) return;
    setState('sending');
    try {
      await sendBlogQuestion({
        name: name.trim() || 'Blog reader',
        email: email.trim(),
        message: `[Blog question] /blog/${slug}\nArticle: ${title}\n\n${question.trim()}`,
      });
      setState('sent');
      setQuestion('');
      try {
        trackTelemetryEvent('blog_question_submit', { current_page: `/blog/${slug}` });
        window.dataLayer?.push({ event: 'blog_question_submit', blog_slug: slug });
      } catch (e) { /* tracking is best effort */ }
    } catch (error) {
      setState('error');
    }
  };

  return (
    <section className="rkblog-question" aria-labelledby="rkblog-question-title">
      <h2 id="rkblog-question-title" className="rkblog-question-title">Have a question about this article?</h2>
      <p className="rkblog-question-lead">
        Ask us. We reply by email, usually within one business day, and we may add the answer to this page without your name.
      </p>
      {state === 'sent' ? (
        <p className="rkblog-question-done" role="status">
          Thanks, we got your question. Watch your inbox for our reply.
        </p>
      ) : (
        <form className="rkblog-question-form" onSubmit={onSubmit}>
          <label htmlFor="rkq-question">Your question</label>
          <textarea id="rkq-question" required minLength={10} maxLength={2000} rows={4}
            value={question} onChange={(e) => setQuestion(e.target.value)} />
          <div className="rkblog-question-row">
            <div>
              <label htmlFor="rkq-email">Email (for our reply)</label>
              <input id="rkq-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div>
              <label htmlFor="rkq-name">First name (optional)</label>
              <input id="rkq-name" type="text" maxLength={60} value={name} onChange={(e) => setName(e.target.value)} />
            </div>
          </div>
          <input className="rkblog-question-hp" tabIndex={-1} autoComplete="off" aria-hidden="true"
            value={website} onChange={(e) => setWebsite(e.target.value)} name="website" />
          <button type="submit" className="rkblog-question-btn" disabled={state === 'sending'}>
            {state === 'sending' ? 'Sending...' : 'Send question'}
          </button>
          {state === 'error' && (
            <p className="rkblog-question-error" role="alert">
              That didn't go through. Try again, or email support@rkubeservices.com or call (984) 234-7030.
            </p>
          )}
        </form>
      )}
    </section>
  );
}

export default BlogQuestionBox;
